import { createSlice } from "@reduxjs/toolkit";
import {
  PaymentStep_Enum,
  TerminalType_Enum,
} from "services/sale/common/enums";
import { GetTripDetail_Response } from "services/sale/passenger/types";

export interface CommonRequestModel {
  //-----submitPaymentModel-----------
  serial: string;
  platformType: TerminalType_Enum | null;
  tripPrice: string;
  tripOrderId: string;
  tripNo: string;
  tripId: number;
  retryButton: boolean | null;
  paymentLoading: boolean;
  //-----sepehr POS Config Model-----------
  localIP: number | null;
  localPort: string;
  posSerial: string;
  terminalId: string;
  webServiceIP: string;
  webServicePort: string;
  tokenId: string;
  getConfig: boolean | null;
  paymentStep: PaymentStep_Enum | null;

  //------Payment Info----------
  versionName: string;
  sessionId: string;
  applicationId: string;
  transactionAmount: string;
  resultCode: number | null;
  retrievalReferencedNumber: number | null;
  referenceId: string;
  dateOfTransaction: string;
  timeOfTransaction: string;
  maskedCardNumber: string;
  bIN: string;
  terminalIdPayment: string;
  printData: GetTripDetail_Response;
  submitTripErrorMsg: string[];
}
const commonSlice = createSlice({
  name: "commonSlice",
  initialState: {} as CommonRequestModel,
  reducers: {
    //اپدیت داده ها
    updateData: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
    cleareData: (state, action) => {
      state = {} as CommonRequestModel;
      return state;
    },
  },
});

export default commonSlice;
